module.exports = __webpack_public_path__ + "static/media/4399.6f045da0.jpg";